import React, { useCallback, useEffect, useState } from 'react'

import { useSelector } from 'react-redux'
import Colors from 'utils/Colors'
import { applicationApprovalByRiskStats } from 'services/apiKYP'
import DataLoadErrorCard from '../DataLoadErrorCard'
import BarChart from '../BarChart'
import { monthToAbbr } from '../../../utils/functions'


const initialState = {
  labels: [],
  datasets: [
    {
      label: 'Risco baixo',
      backgroundColor: Colors.approved,
      borderColor: Colors.approved,
      borderWidth: 1,
      data: [],
    },
    {
      label: 'Risco médio',
      backgroundColor: Colors.info,
      borderColor: Colors.info,
      borderWidth: 1,
      data: [],
    },
    {
      label: 'Risco alto',
      backgroundColor: Colors.orange,
      borderColor: Colors.red,
      borderWidth: 1,
      data: [],
    }, 
    {
      label: 'Risco muito alto',
      backgroundColor: Colors.red,
      borderColor: Colors.red,
      borderWidth: 1,
      data: [],
    },
  ],
}

const ApplicationApprovalByRiskChart = ({ startDate, endDate, shouldFetchData }) => {
  const token = useSelector((state) => state.auth.access_token)

  const [chartData, setChartData] = useState(initialState)
  const [isLoading, setIsLoading] = useState(true)
  const [fetchError, setFetchError] = useState(null)

  const title = 'Riscos dos AIs aprovados'

  const initializeData = (data) => {
    const labels = data?.stats?.map(d => `${monthToAbbr(d.month)}/${d.year}`)
    const lowData = data?.stats?.map(d => d.low)
    const mediumData = data?.stats?.map(d => d.medium)
    const highData = data?.stats?.map(d => d.high)
    const veryHighData = data?.stats?.map(d => d.very_high)

    const updatedData = { ...chartData }
    updatedData.labels = labels
    updatedData.datasets[0].data = lowData
    updatedData.datasets[1].data = mediumData
    updatedData.datasets[2].data = highData
    updatedData.datasets[3].data = veryHighData

    setChartData(updatedData)
  }
  
  const fetchData = useCallback(() => {

    if (!startDate || !endDate || new Date(startDate) > new Date(endDate)) {
      return
    }

    setFetchError(null)
    setIsLoading(true)

    const params = {
      start_date: startDate,
      end_date: endDate,
    }

    applicationApprovalByRiskStats(token, params)
      .then((response) => {
        const { data } = response
        initializeData(data)
      })
      .catch((error) => {
        if (error.response && error.response.data.message) {
          setFetchError(error.response.data.message)
        } else {
          setFetchError('Não conseguimos acessar os dados no momento. Por favor, tente novamente.')
        }
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [token, startDate, endDate])


  useEffect(() => {
    if (shouldFetchData) {
      fetchData()
    }
  }, [shouldFetchData])

  return (
    fetchError ? <DataLoadErrorCard message={fetchError} actionCallback={fetchData} title={title} /> : (
      <BarChart
        data={chartData}
        size='medium'
        displayLegend={true}
        title={title}
        isLoading={isLoading}
      />
    )
  )
}


export default ApplicationApprovalByRiskChart
